var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.62 25.99",
    style: {
      enableBackground: "new 0 0 23.62 25.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#fff;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.37,0.6H4.25c-2.05,0-3.71,1.66-3.71,3.71v15.12c0,2.05,1.66,3.71,3.71,3.71h15.12 c2.05,0,3.71-1.66,3.71-3.71V4.31C23.08,2.26,21.42,0.6,19.37,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.96,2.49H4.65c-1.23,0-2.23,1-2.23,2.23v14.31c0,1.23,1,2.23,2.23,2.23h14.31c1.23,0,2.23-1,2.23-2.23V4.72 C21.2,3.49,20.2,2.49,18.96,2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.63,25.4L5.63,25.4c-0.82,0-1.49-0.67-1.49-1.49v-0.77h2.98v0.77C7.12,24.74,6.45,25.4,5.63,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.99,25.4L17.99,25.4c-0.82,0-1.49-0.67-1.49-1.49v-0.77h2.98v0.77C19.48,24.74,18.81,25.4,17.99,25.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.81,
    cy: 11.87,
    r: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.93,10.48V5.37c0-0.49,0.4-0.88,0.88-0.88l0,0c0.49,0,0.88,0.4,0.88,0.88v5.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.41,12.76H5.3c-0.49,0-0.88-0.4-0.88-0.88l0,0c0-0.49,0.4-0.88,0.88-0.88h5.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.69,13.27v5.11c0,0.49-0.4,0.88-0.88,0.88l0,0c-0.49,0-0.88-0.4-0.88-0.88v-5.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.21,10.99h5.11c0.49,0,0.88,0.4,0.88,0.88l0,0c0,0.49-0.4,0.88-0.88,0.88h-5.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.22,10.99c0.38-2.42,2.29-4.32,4.7-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.93,17.46c-2.42-0.38-4.32-2.29-4.7-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,12.76c-0.38,2.42-2.29,4.32-4.7,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.69,6.29c2.42,0.38,4.32,2.29,4.7,4.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.ee098d22ae29436dddfb7501e9e41d7d.svg";
export { ForwardRef as ReactComponent };